// import React, { useState } from 'react';
// import { signInWithEmailAndPassword } from 'firebase/auth';
// import { doc, setDoc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
// import { auth, db } from '../firebase/config';
// import { Mail, Lock, Eye, EyeOff, Loader } from 'lucide-react';
// import './Login.css';

// const Login = () => {
//   const [formData, setFormData] = useState({
//     email: '',
//     password: ''
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//     setError('');
//   };

//   // Function to update login history in Firestore
//   const updateLoginHistory = async (user) => {
//     try {
//       const userRef = doc(db, 'users', user.uid);
//       const userDoc = await getDoc(userRef);
      
//       const currentLoginData = {
//         timestamp: serverTimestamp(),
//         email: user.email,
//         uid: user.uid
//       };

//       if (userDoc.exists()) {
//         // User exists - update previous login and set new current login
//         const userData = userDoc.data();
//         const previousLogin = userData.currentLogin || null;
        
//         await updateDoc(userRef, {
//           previousLogin: previousLogin,
//           currentLogin: currentLoginData,
//           lastUpdated: serverTimestamp(),
//           loginCount: (userData.loginCount || 0) + 1
//         });
//       } else {
//         // New user - create document with current login
//         await setDoc(userRef, {
//           email: user.email,
//           uid: user.uid,
//           currentLogin: currentLoginData,
//           previousLogin: null,
//           loginCount: 1,
//           createdAt: serverTimestamp(),
//           lastUpdated: serverTimestamp()
//         });
//       }
      
//       console.log('Login history updated successfully');
//     } catch (error) {
//       console.error('Error updating login history:', error);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!formData.email || !formData.password) {
//       setError('Email and password are required');
//       return;
//     }

//     setLoading(true);
//     setError('');

//     try {
//       const userCredential = await signInWithEmailAndPassword(auth, formData.email, formData.password);
//       const user = userCredential.user;
      
//       // Update login history in Firestore
//       await updateLoginHistory(user);
      
//     } catch (error) {
//       console.error('Login error:', error);
//       switch (error.code) {
//         case 'auth/invalid-email':
//           setError('Invalid email address');
//           break;
//         case 'auth/user-disabled':
//           setError('This account has been disabled');
//           break;
//         case 'auth/user-not-found':
//           setError('No account found with this email');
//           break;
//         case 'auth/wrong-password':
//           setError('Incorrect password');
//           break;
//         case 'auth/network-request-failed':
//           setError('Network error. Please check your connection');
//           break;
//         default:
//           setError('Login failed. Please try again');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="login-container">
//       <div className="login-card">
//         <div className="login-header">
//           <h1>Welcome Back</h1>
//           <p>Sign in to your secure account</p>
//         </div>

//         <form onSubmit={handleSubmit} className="login-form">
//           <div className="input-group">
//             <Mail className="input-icon" />
//             <input
//               type="email"
//               name="email"
//               placeholder="Enter your email"
//               value={formData.email}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="input-group">
//             <Lock className="input-icon" />
//             <input
//               type={showPassword ? "text" : "password"}
//               name="password"
//               placeholder="Enter your password"
//               value={formData.password}
//               onChange={handleChange}
//               required
//             />
//             <button
//               type="button"
//               className="password-toggle"
//               onClick={() => setShowPassword(!showPassword)}
//             >
//               {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//             </button>
//           </div>

//           {error && <div className="error-message">{error}</div>}

//           <button 
//             type="submit" 
//             className="login-button"
//             disabled={loading}
//           >
//             {loading ? (
//               <Loader className="spinner" />
//             ) : (
//               'Sign In'
//             )}
//           </button>
//         </form>

//         <div className="security-notice">
//           <p>🔒 Secure Session - Login expires when browser closes</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;


import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase/config';
import { Mail, Lock, Eye, EyeOff, Loader } from 'lucide-react';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  // Function to update login history in Firestore
  const updateLoginHistory = async (user) => {
    try {
      const userRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userRef);
      
      const currentLoginData = {
        timestamp: serverTimestamp(),
        email: user.email,
        uid: user.uid
      };

      if (userDoc.exists()) {
        // User exists - update previous login and set new current login
        const userData = userDoc.data();
        const previousLogin = userData.currentLogin || null;
        
        await updateDoc(userRef, {
          previousLogin: previousLogin,
          currentLogin: currentLoginData,
          lastUpdated: serverTimestamp(),
          loginCount: (userData.loginCount || 0) + 1
        });
      } else {
        // New user - create document with current login
        await setDoc(userRef, {
          email: user.email,
          uid: user.uid,
          currentLogin: currentLoginData,
          previousLogin: null,
          loginCount: 1,
          createdAt: serverTimestamp(),
          lastUpdated: serverTimestamp()
        });
      }
      
      // console.log('Login history updated successfully');
    } catch (error) {
      // console.error('Error updating login history:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.email || !formData.password) {
      setError('Email and password are required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const userCredential = await signInWithEmailAndPassword(auth, formData.email, formData.password);
      const user = userCredential.user;
      
      // Update login history in Firestore
      await updateLoginHistory(user);
      
    } catch (error) {
      // console.error('Login error:', error);
      switch (error.code) {
        case 'auth/invalid-email':
          setError('Invalid email address');
          break;
        case 'auth/user-disabled':
          setError('This account has been disabled');
          break;
        case 'auth/user-not-found':
          setError('No account found with this email');
          break;
        case 'auth/wrong-password':
          setError('Incorrect password');
          break;
        case 'auth/network-request-failed':
          setError('Network error. Please check your connection');
          break;
        default:
          setError('Login failed. Please try again');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-main-container">
      <div className="login-main-card">
        <div className="login-main-header">
          <h1>Welcome Back</h1>
          <p>Sign in to your secure account</p>
        </div>

        <form onSubmit={handleSubmit} className="login-main-form">
          <div className="login-main-input-group">
            <Mail className="login-main-input-icon" />
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="login-main-input-group">
            <Lock className="login-main-input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <button
              type="button"
              className="login-main-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          {error && <div className="login-main-error-message">{error}</div>}

          <button 
            type="submit" 
            className="login-main-button"
            disabled={loading}
          >
            {loading ? (
              <Loader className="login-main-spinner" />
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        <div className="login-main-security-notice">
          <p>🔒 Secure Session - Login expires when browser closes</p>
        </div>
      </div>
    </div>
  );
};

export default Login;